import { useLocation } from "react-router-dom";
import React from "react";
import { ReactComponent as EditPic } from "../assets/editpencil.svg";
import { ReactComponent as RemovePic } from "../assets/redfilltrash.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ReactComponent as ActionIcon } from "../assets/actionIcon.svg";

const TableActionMenu = ({ cell, row, handleDelete }) => {
  console.log("rowrow", row.date);
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div
        onClick={handleClick}
        id="basic-button "
        aria-controls={open ? "basic-menu" : undefined}
        className="pointer-cursor"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <ActionIcon className="action-icon" />
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        // classes="testing"
        onClose={handleClose}
      >
        <MenuItem
          className="actionbuttonE"
          onClick={() => {
            window.location.href = `${location.pathname}/calculator?id=${row._id}`;
            handleClose();
          }}
        >
          {" "}
          <EditPic stroke="grey" className="mr-2" /> Update Calculation
        </MenuItem>
        <MenuItem
          className="actionbutton removebuttonE"
          onClick={() => {
            handleDelete(row._id);
            handleClose();
          }}
        >
          <RemovePic className="mr-2" /> Remove Calculation
        </MenuItem>
      </Menu>
    </div>
  );
};

export default TableActionMenu;
